(function () {
  const DESKTOP_MIN_WIDTH = 990;
  const STOP_DEBOUNCE_MS = 80;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function canUseHoverSlideshow() {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }

  function setActiveImage(images, index) {
    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === index);
    });
    return index;
  }

  function initCardHoverSlideshow(root) {
    if (!canUseHoverSlideshow() || prefersReducedMotion()) {
      return;
    }

    const scope = root || document;
    scope.querySelectorAll('[data-card-hover-slideshow]').forEach((container) => {
      if (container.dataset.slideshowBound === 'true') {
        return;
      }

      const wrapper = container.closest('.card-wrapper');
      const images = Array.from(container.querySelectorAll('.card-hover-slideshow__image'));
      if (!wrapper || images.length < 2) {
        return;
      }

      const hoverImages = images.slice(1);
      if (hoverImages.length < 1) {
        return;
      }

      container.dataset.slideshowBound = 'true';
      const intervalMs = Number.parseInt(container.dataset.interval || '1040', 10) || 1040;
      let timer = null;
      let stopTimer = null;
      let hoverIndex = 0;

      const activeIndex = images.findIndex((image) => image.classList.contains('is-active'));
      if (activeIndex < 0) {
        setActiveImage(images, 0);
      }

      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        hoverIndex = 0;
        setActiveImage(images, 0);
      };

      const scheduleStop = () => {
        if (stopTimer) {
          clearTimeout(stopTimer);
        }
        stopTimer = window.setTimeout(() => {
          stopTimer = null;
          stop();
        }, STOP_DEBOUNCE_MS);
      };

      const cancelScheduledStop = () => {
        if (stopTimer) {
          clearTimeout(stopTimer);
          stopTimer = null;
        }
      };

      const start = () => {
        cancelScheduledStop();

        if (timer) {
          clearInterval(timer);
          timer = null;
        }

        hoverIndex = 0;
        setActiveImage(images, 1);

        if (hoverImages.length === 1) {
          return;
        }

        timer = window.setInterval(() => {
          hoverIndex = (hoverIndex + 1) % hoverImages.length;
          setActiveImage(images, hoverIndex + 1);
        }, intervalMs);
      };

      wrapper.addEventListener('mouseenter', start);
      wrapper.addEventListener('mouseleave', scheduleStop);
      wrapper.addEventListener('pointerenter', start);
      wrapper.addEventListener('pointerleave', scheduleStop);
      wrapper.addEventListener('focusin', start);
      wrapper.addEventListener('focusout', (event) => {
        if (!wrapper.contains(event.relatedTarget)) {
          scheduleStop();
        }
      });
    });
  }

  window.initCardHoverSlideshow = initCardHoverSlideshow;

  document.addEventListener('DOMContentLoaded', () => initCardHoverSlideshow());
  document.addEventListener('shopify:section:load', (event) => initCardHoverSlideshow(event.target));
})();
